<div (click)="onButtonClick()" class="play-icon" [ngClass]="{'block-button' : videoStateType === blockInteraction}">
  <i [class]="icon"></i>
</div>
